export const procurementDe = {
  orderStatus: {
    DRAFT: 'Entwurf',
    SENT: 'Versendet',
    CONFIRMED: 'Bestätigt',
    PARTIALLY_RECEIVED: 'Teilgeliefert',
    RECEIVED: 'Vollständig geliefert',
    BILLED: 'Abgerechnet',
    CANCELLED: 'Storniert',
  },
  receiptStatus: {
    DRAFT: 'Entwurf',
    POSTED: 'Eingebucht',
    CANCELLED: 'Storniert',
  },
  qualityStatus: {
    ACCEPTED: 'Angenommen',
    DAMAGED_REJECTED: 'Beschädigt / abgelehnt',
    UNDER_QUARANTINE: 'In Quarantäne',
  },
  invoiceStatus: {
    DRAFT: 'Wartet auf Prüfung',
    MATCHED: 'Geprüft',
    DISCREPANCY: 'Preisdifferenz',
    APPROVED_FOR_PAYMENT: 'Zahlungsfreigabe erteilt',
    PAID: 'Bezahlt',
    CANCELLED: 'Storniert',
  },
  matchStatus: {
    PERFECT_MATCH: 'Exakter Match',
    TOLERANCE_ACCEPTED: 'Innerhalb Toleranz',
    PRICE_MISMATCH: 'Preisabweichung',
    QTY_MISMATCH: 'Mengenabweichung',
    MANUALLY_OVERRIDDEN: 'Manuell akzeptiert',
  },
  orders: {
    invalidNumber: 'Gültige Zahl eingeben; die Menge muss größer als 0 sein.',
    invalidTax: 'Steuersatz zwischen 0 und 100 eingeben.',
    title: 'Bestellungen',
    subtitle: 'Lieferantenbestellungen erfassen, versenden und nachverfolgen.',
    cardTitle: 'Bestellübersicht',
    cardDescription: 'Alle Bestellungen mit Lieferstatus und Bestellwert.',
    create: 'Neue Bestellung',
    newReceipt: 'Wareneingang erfassen',
    searchPlaceholder: 'Bestellnummer oder Lieferant suchen',
    error: 'Die Bestellungen konnten nicht geladen werden.',
    emptyTitle: 'Keine Bestellungen gefunden',
    emptyHint: 'Legen Sie eine Bestellung an, um den Einkaufsprozess zu starten.',
    columns: {
      number: 'Bestellnummer',
      supplier: 'Lieferant',
      orderDate: 'Bestelldatum',
      delivery: 'Liefertermin',
      status: 'Status',
      total: 'Bestellwert',
      article: 'Artikel',
      quantity: 'Menge',
      unit: 'Einheit',
      price: 'EK-Preis',
      tax: 'USt. %',
      lineNet: 'Netto',
      freeText: 'Freitext',
    },
    created: 'Bestellung {{number}} wurde angelegt.',
    saved: 'Bestellung gespeichert.',
    loadError: 'Die Bestellung konnte nicht geladen werden.',
    newTitle: 'Neue Bestellung',
    editorHint: 'Positionen, Konditionen und Lieferadresse der Bestellung.',
    pdf: 'PDF herunterladen',
    send: 'Per E-Mail senden',
    confirm: 'Auftragsbestätigung erfasst',
    confirmed: 'Bestellung als bestätigt markiert.',
    cancel: 'Stornieren',
    cancelled: 'Bestellung wurde storniert.',
    cancelTitle: 'Bestellung {{number}} stornieren?',
    cancelDescription:
      'Die Bestellung wird dauerhaft storniert und kann anschließend nicht mehr bearbeitet werden.',
    cancelReason: 'Stornogrund',
    receiveGoods: 'Wareneingang erfassen',
    itemsTitle: 'Positionen',
    itemsHint: 'Artikel des Lieferanten mit Staffelpreisen oder freie Textpositionen.',
    articlePlaceholder: 'Artikel suchen',
    noSupplierProducts: 'Für diesen Lieferanten sind keine Artikel hinterlegt.',
    freeTextPlaceholder: 'Bezeichnung der Position',
    removeItem: 'Position entfernen',
    addItem: 'Position hinzufügen',
    net: 'Netto',
    tax: 'Umsatzsteuer',
    gross: 'Brutto',
    headerTitle: 'Bestellkopf',
    headerHint: 'Lieferant, Termine und Konditionen.',
    supplier: 'Lieferant',
    supplierPlaceholder: 'Lieferant suchen',
    noSuppliers: 'Keine Lieferanten gefunden.',
    minimumOrderValue: 'Mindestbestellwert',
    deliveryTime: 'Lieferzeit',
    days: '{{count}} Tage',
    expectedDelivery: 'Voraussichtlicher Liefertermin',
    paymentTerms: 'Zahlungsziel (Tage)',
    incoterms: 'Incoterms',
    storageArea: 'Ziel-Lagerbereich',
    storageAreaHint: 'Wird beim Wareneingang vorbelegt.',
    notes: 'Bemerkungen',
    email: {
      title: 'Bestellung versenden',
      description: 'Die Bestellung wird als PDF angehängt und der Status auf „Versendet“ gesetzt.',
      to: 'Empfänger',
      subject: 'Betreff',
      body: 'Nachricht',
      submit: 'Senden',
      sent: 'Bestellung wurde versendet.',
      defaultSubject: 'Bestellung {{number}}',
      defaultBody:
        'Guten Tag,\n\nanbei erhalten Sie unsere Bestellung {{number}}.\n\nMit freundlichen Grüßen',
    },
  },
  receipts: {
    warehouseRequired:
      'Wählen Sie das Lager zu diesem Lagerplatz. Eine Bezeichnung allein ordnet keinen Bestand zu.',
    title: 'Wareneingänge',
    subtitle: 'Gebuchte und offene Wareneingänge im Überblick.',
    cardTitle: 'Wareneingangsübersicht',
    cardDescription: 'Alle erfassten Lieferungen mit Bezug zur Bestellung.',
    create: 'Wareneingang erfassen',
    searchPlaceholder: 'Beleg-, Bestell- oder Lieferscheinnummer',
    error: 'Die Wareneingänge konnten nicht geladen werden.',
    listEmptyTitle: 'Keine Wareneingänge vorhanden',
    listEmptyHint: 'Erfassen Sie eine Lieferung, um den Bestand zu aktualisieren.',
    columns: {
      number: 'Belegnummer',
      supplier: 'Lieferant',
      order: 'Bestellung',
      deliveryNote: 'Lieferschein',
      date: 'Eingangsdatum',
      status: 'Status',
    },
    terminalTitle: 'Wareneingang erfassen',
    terminalSubtitle: 'Bestellung scannen, Mengen prüfen und Bestand verbindlich fortschreiben.',
    selectOrder: 'Bestellung auswählen',
    selectOrderHint: 'Bestellnummer scannen oder aus den offenen Bestellungen wählen.',
    scanOrder: 'Bestellnummer scannen',
    scanPlaceholder: 'z. B. EK-2026-0001',
    openOrders: 'Offene Bestellungen',
    openOrdersPlaceholder: 'Bestellung wählen',
    emptyTitle: 'Noch keine Bestellung gewählt',
    emptyHint: 'Scannen Sie den Barcode des Lieferscheins oder wählen Sie eine Bestellung.',
    loadError: 'Die Bestellpositionen konnten nicht geladen werden.',
    positionsTitle: 'Positionen zu {{number}}',
    nothingOpen: 'Für diese Bestellung sind keine offenen Mengen vorhanden.',
    batchManaged: 'Chargenpflichtig',
    open: 'Offen: {{quantity}} {{unit}}',
    quantityReceived: 'Gelieferte Menge',
    quantityInvalid: 'Bitte eine Menge größer als 0 erfassen.',
    batchNumber: 'Chargennummer',
    batchRequired: 'Für chargengeführte Artikel ist eine Chargennummer Pflicht.',
    expiryDate: 'Mindesthaltbarkeitsdatum',
    expiryRequired: 'Bitte ein MHD erfassen.',
    storageLocation: 'Lagerfach / Regalplatz',
    storageLocationPlaceholder: 'z. B. A-03-12',
    quality: 'Qualität',
    deliveryNoteTitle: 'Lieferschein',
    deliveryNoteHint: 'Lieferscheinnummer erfassen und Scan oder Foto anhängen.',
    deliveryNoteNumber: 'Lieferscheinnummer',
    storageArea: 'Lagerbereich',
    notes: 'Bemerkungen',
    attachScan: 'Lieferschein scannen oder hochladen',
    noScan: 'Kein Beleg angehängt',
    blocked: '{{count}} Position(en) sind noch unvollständig.',
    ready: '{{count}} Position(en) werden eingebucht.',
    submit: 'Wareneingang verbindlich einbuchen & Bestand aktualisieren',
    posted: 'Wareneingang {{number}} wurde gebucht und der Bestand aktualisiert.',
  },
  invoices: {
    title: 'Eingangsrechnungen',
    subtitle: 'Kreditoren nach Fälligkeit und Skontofrist überwachen.',
    cardTitle: 'Rechnungseingang',
    cardDescription: 'Alle Lieferantenrechnungen mit Prüf- und Zahlungsstatus.',
    create: 'Rechnung erfassen',
    createTitle: 'Eingangsrechnung erfassen',
    createDescription: 'Rechnung zur Bestellung erfassen und Beleg hinterlegen.',
    created: 'Rechnung {{number}} wurde erfasst.',
    searchPlaceholder: 'Rechnungsnummer oder Lieferant suchen',
    error: 'Die Eingangsrechnungen konnten nicht geladen werden.',
    emptyTitle: 'Keine Eingangsrechnungen gefunden',
    emptyHint: 'Erfassen Sie eine Lieferantenrechnung, um die Prüfung zu starten.',
    blocked: 'Zahlung gesperrt',
    order: 'Bestellung',
    orderPlaceholder: 'Bestellung wählen',
    number: 'Rechnungsnummer',
    invoiceDate: 'Rechnungsdatum',
    discountPercent: 'Skonto %',
    discountDays: 'Skontotage',
    document: 'Rechnungsbeleg (PDF oder Scan)',
    addItem: 'Position hinzufügen',
    removeItem: 'Position entfernen',
    submit: 'Rechnung erfassen',
    discountHint: 'Skonto {{percent}} % noch {{count}} Tage nutzbar',
    discountHint_one: 'Skonto {{percent}} % nur noch heute nutzbar',
    discountGone: 'Skontofrist abgelaufen',
    kpi: {
      open: 'Offener Betrag',
      overdue: 'Überfällig',
      discrepancy: 'Mit Abweichung',
      discount: 'Skontofrist läuft',
    },
    columns: {
      number: 'Rechnungsnummer',
      supplier: 'Lieferant',
      invoiceDate: 'Rechnungsdatum',
      dueDate: 'Fällig am',
      discount: 'Skonto',
      status: 'Status',
      gross: 'Brutto',
      description: 'Bezeichnung',
      quantity: 'Menge',
      unitPrice: 'Einzelpreis',
      taxRate: 'USt. %',
    },
  },
  match: {
    title: '3-Wege-Abgleich {{number}}',
    loadError: 'Der Rechnungsabgleich konnte nicht geladen werden.',
    run: 'Abgleich neu berechnen',
    clear: 'Alle Positionen stimmen überein.',
    discrepancies: '{{count}} Position(en) weichen ab.',
    documentTitle: 'Lieferantenrechnung',
    documentError: 'Der Beleg konnte nicht geladen werden.',
    noDocument: 'Kein Beleg hinterlegt',
    noDocumentHint: 'Laden Sie die Rechnung als PDF oder Scan hoch, um sie hier zu prüfen.',
    upload: 'Beleg hochladen',
    uploaded: 'Beleg wurde hinterlegt.',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    rotate: 'Drehen',
    reload: 'Neu laden',
    tableTitle: 'Bestellung / Lieferung / Rechnung',
    counts: '{{matched}} exakt · {{tolerance}} in Toleranz · {{discrepancy}} abweichend',
    columns: {
      position: 'Pos.',
      description: 'Bezeichnung',
      ordered: 'Bestellt',
      delivered: 'Geliefert',
      invoiced: 'Berechnet',
      variance: 'Differenz',
      status: 'Status',
    },
    totalVariance: 'Gesamtdifferenz',
    approve: 'Freigeben zur Zahlung',
    approved: 'Rechnung wurde zur Zahlung freigegeben.',
    acceptTolerance: 'Manuelle Toleranz akzeptieren',
    override: {
      title: 'Abweichung manuell akzeptieren',
      description:
        'Die Begründung wird revisionssicher im Abgleichprotokoll und im Audit-Log gespeichert.',
      reason: 'Begründung',
      submit: 'Abweichung akzeptieren',
      saved: 'Abweichung wurde akzeptiert.',
    },
    complaint: {
      action: 'Reklamation senden',
      title: 'Reklamation an Lieferanten',
      description: 'Die Nachricht wird per E-Mail versendet und protokolliert.',
      to: 'E-Mail-Adresse',
      subject: 'Betreff',
      body: 'Nachricht',
      submit: 'Reklamation senden',
      sent: 'Reklamation wurde versendet.',
      defaultSubject: 'Rückfrage zu Rechnung {{number}}',
      defaultBody:
        'Guten Tag,\n\nbei der Prüfung Ihrer Rechnung {{number}} haben wir eine Abweichung von {{variance}} gegenüber Bestellung und Wareneingang festgestellt.\n\nBitte prüfen Sie den Vorgang und senden Sie uns eine korrigierte Rechnung.\n\nMit freundlichen Grüßen',
    },
  },
} as const;
